// src/layouts/OneColumnContent/OneColumnContent.js

import React from "react"
import styled from 'styled-components'

const OneColumnContent = ({ pbFullContent }) => {

  return (
    <BlockContent>
        <div 
        data-sal="slide-up"
        data-sal-duration="1000"
        data-sal-delay="300"
        data-sal-easing="ease"
        dangerouslySetInnerHTML={{__html: pbFullContent}} />
    </BlockContent>
  )
}

const BlockContent = styled.section`
    max-width: 1160px;
    width: 100%;
    margin: 50px auto;
    padding: 0px;
    h2 {
      font-family: "Nobel",sans-serif;
      font-weight: 700;
      font-style: normal;
      font-size: 50px;
      color: #2b2520;
      margin-top: 30px;
    }
    h3 {
      font-family: "Nobel",sans-serif;
      font-weight: 700;
      font-style: normal;
      font-size: 50px;
      line-height: 60px;
      color: #2b2520;
      margin-top: 30px;
  }
  h4 {
      font-family: "Nobel",sans-serif;
      font-weight: 700;
      font-style: normal;
      font-size: 40px;
      line-height: 48px;
      color: #2b2520;
      margin-top: 30px;
  }
    p, li {
      font-family: "Work Sans";
      font-size: 18px;
      font-weight: 400;
      line-height: 38px;
      color: #777c7c;
      margin-bottom: 0px;
      a {
          color: #C44C4A;
      }
    }
    p {
        margin-bottom: 30px;
    }
    ul,ol {
        margin-left: 35px;
        margin-bottom: 30px;
    }
    @media(max-width:1000px) {
      max-width: 590px;
      flex-wrap: wrap;
      h2 {
          font-size: 44px;
          line-height: 1.3;
          margin-bottom: 10px;
          padding-left: 0;
      }
      h3 {
          font-size: 36px;
          line-height: 1.3;
          margin-bottom: 10px;
      }
      h4 {
          font-size: 28px;
          line-height: 1.3;
          margin-bottom: 10px;
      }
  }
  @media(max-width:767px) {
      max-width: 440px;
      margin: 20px auto;
      padding: 0;
      h2 {
          font-size: 36px;
      }
      h3 {
          font-size: 28px;
      }
      h4 {
          font-size: 20px;
      }
      p, li {
          font-size: 16px;
          line-height: 1.6;
      }
      ul {
        margin-left: 10px;
    }
  }
`

export default OneColumnContent